import { Base } from '@studiometa/js-toolkit';

/**
 *
 */
export default class Search extends Base {
  static config = {
    name: 'Search',
    refs: ['iconSearch', 'formSearch', 'inputSearch'],
  };

  /**
   *
   */
  mounted() {
    this.$refs.iconSearch;
    this.$refs.formSearch;
    this.$refs.inputSearch;
  }

  /**
   *
   */
  onIconSearchClick() {
    const formSearch = Array.isArray(this.$refs.formSearch)
      ? this.$refs.formSearch[0]
      : this.$refs.formSearch;
    const inputSearch = Array.isArray(this.$refs.inputSearch)
      ? this.$refs.inputSearch[0]
      : this.$refs.inputSearch;

    if (!formSearch || !inputSearch) {
      return;
    }

    formSearch.classList.remove('hidden');
    formSearch.classList.toggle('flex');
    setTimeout(() => {
      formSearch.style.transform = 'translateY(0)';
      inputSearch.focus();
    }, 1);
  }

  /**
   *
   */
  closeSearch() {
    const formSearch = Array.isArray(this.$refs.formSearch)
      ? this.$refs.formSearch[0]
      : this.$refs.formSearch;
    setTimeout(() => {
      formSearch.classList.remove('flex');
      formSearch.classList.add('hidden');
    }, 501);
    formSearch.style.transform = 'translateY(-100%)';
  }
}
